export const formatTimeRemaining = (blockedUntil: Date): string => {
    const now = new Date();
    const diff = blockedUntil.getTime() - now.getTime();
    const minutes = Math.ceil(diff / (1000 * 60));
    return `${minutes} dakika`;
  };